// extracted by mini-css-extract-plugin
export default {"back":"BackToTop_back__f3Gyx","back__paragraph":"BackToTop_back__paragraph__QR7aZ","back__link":"BackToTop_back__link__SvOKI"};